<p-multiSelect
  [options]="items"
  [(ngModel)]="selectedItems"
  appendTo="body"
  placeholder="Izaberite repromaterijale robe"
  (onChange)="selectedItemsOnChange()"
></p-multiSelect>
